import type { ECouponDataSource } from '~/api/data-source/e-coupon';
import { eCouponDataSource } from '~/api/data-source/e-coupon';
import type { ECouponDetail } from '~/api/model';
import { eCouponDetailSchema, parseModel } from '~/api/model';

export interface ECouponRepository {
  getECouponDetail(eCouponId: string): Promise<ECouponDetail>;
}

export class ECouponRepositoryImpl implements ECouponRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly dataSource: ECouponDataSource = eCouponDataSource,
  ) {}

  async getECouponDetail(eCouponId: string) {
    const response = await this.dataSource.getECouponDetail(eCouponId);
    return parseModel(eCouponDetailSchema, response, 'ECouponDetail');
  }
}

export const eCouponRepository = new ECouponRepositoryImpl();
